export enum LoadingStatus {
    NotStarted = 0,
    InProgress,
    Done,
}